// extracted by mini-css-extract-plugin
module.exports = {"body":"DefaultDynamicSeoFooterContent_body__s4yDm","benefits":"DefaultDynamicSeoFooterContent_benefits__eIz_P"};